export const ENTITY_TYPE = {
    CAMPAIGN: 'campaigns',
    CAMPAIGN_GROUP: 'campaign groups',
};
